import MainLogo from './login-logo.png';

import SideBarOpen from './logo.png'
import SideBarClosed from './favicon.svg'

import dashboad from './dashboad.png'

import LoginBanner from './sales.jpg'

export const assets = {
  MainLogo, dashboad, SideBarOpen, SideBarClosed, LoginBanner
};